/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TrackEvent = {
    impression: 'impression',
    click: 'click',
    claim_cta_click: 'claim_cta_click',
    connect: 'connect',
    teaser_click: 'teaser_click',
    participate: 'participate',
    complete: 'complete',
    claim: 'claim',
    open: 'open',
    follow: 'follow'
} as const;
export type TrackEvent = typeof TrackEvent[keyof typeof TrackEvent];


export function instanceOfTrackEvent(value: any): boolean {
    for (const key in TrackEvent) {
        if (Object.prototype.hasOwnProperty.call(TrackEvent, key)) {
            if (TrackEvent[key as keyof typeof TrackEvent] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TrackEventFromJSON(json: any): TrackEvent {
    return TrackEventFromJSONTyped(json, false);
}

export function TrackEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackEvent {
    return json as TrackEvent;
}

export function TrackEventToJSON(value?: TrackEvent | null): any {
    return value as any;
}

export function TrackEventToJSONTyped(value: any, ignoreDiscriminator: boolean): TrackEvent {
    return value as TrackEvent;
}

